import { React, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

export function EquipmentTypeSelector({ interventionTypes, setInterventionType }) {
    const { t } = useTranslation();  
  const handleTypeChange = async (event) => {
      const newEquipmentType = event.target.value;
      const selectecdInterventionType = interventionTypes.find(type => type.id.toString() === newEquipmentType);

      setInterventionType(selectecdInterventionType);

  };

  return (
    <div className="EquipmentTypeSelector mb-4">
      <Form style={{ maxWidth: '349px' }}>
              <Form.Select className="bg-light" onChange={handleTypeChange} >
                  <option value="">{t('selectDeviceType')}</option>
                  {interventionTypes.map((type) => (
                      <option key={type.id} value={type.id} >{type.name}</option>
                  ))}
        </Form.Select>
      </Form>
    </div>
  );
}
